import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="main-footer footer-style-three ">
      <div className="bg bg-pattern-8"></div>

      {/* Footer Top */}
      <div className="footer-top">
        <div className="bg-overlay-7"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="top-left">
              <h6 className="sub-title text-white">long established fact that a reader</h6>
              <h2 className="title  text-white">"Book your Cab – simple, affordable, reliable!"
              </h2>
            </div>
            <div className="top-right">
              <div className="info-btn">
                <i className="icon fal fa-mobile  text-white"></i>
                <div className="content">
                  <h5 className="title  text-white">call for Cab</h5>
                  <a href="tel:+919594917913" className="phone-no  text-white">+91&nbsp;9594917913</a>
                </div>
              </div>
              <div className="btn-box">
                <a href="/booking" className="theme-btn btn-style-one yellow-line dark-bg hover-light">
                  <span className="btn-title">Book Your Cab</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Widgets Section */}
      <div className="widgets-section">
        <div className="auto-container">
          <div className="row">
            {/* Footer Column 1 */}
            <div className="col-md-6 col-lg-3">
              <div className="footer-widget-box about-us ">
              <h4 className="widget-title">Contact Us</h4>
                <a href="#" className="footer-logo">
                  <img src="/images/logo.png" className='d-none' alt="Logo" />
                </a>

                <ul className="footer-contact text-white">
                  <li>
                    <a href="tel:+919594917913" className='text-white'>
                      <i className="fas fa-phone darkcolorrr"></i> +91 9594917913
                    </a>
                  </li>


                  <li>
                    <a href="mailto:booking@shreecabs24.com" className='text-white'>
                      <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                    </a>
                  </li>

                  <li className='' >
                    <i className="fas fa-map-marker-alt darkcolorrr"></i> SHREE Tours & Travels<br />
                    Maharashtra Co-Operative Housing Society, Yerawada, Pune, Maharashtra India - 411006
                  </li>
                  <li>
                    <div className="contact-map">

                      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2989.372022951472!2d73.8973522!3d18.561875399999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1470c781897%3A0xb25dd8d5491ad17!2sShree%20Tours%20And%20Travels!5e1!3m2!1sen!2sin!4v1742625980644!5m2!1sen!2sin" width="100%" height="200" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                    </div>
                  </li>
                </ul>

              </div>
            </div>

            {/* Footer Column 2 */}
            <div className="footer-column col-lg-3 col-md-6 col-sm-12">
              <div className="footer-widget links-widget">
                <h4 className="widget-title">Services</h4>
                <div className="widget-content">
                  <Link className="mx-md-2 d-block" to="/Pune-to-Kolhapur-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Kolhapur Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Mumbai-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Mumbai Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Sangli-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Sangli Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Mahabaleshwar-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Mahabaleshwar Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Bhimashankar-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Bhimashankar Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Shirdi-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Shirdi Cab</Link>

                  <Link className="mx-md-2" to="/Pune-to-Nashik-Cab"><i className="fas fa-car darkcolorrr"></i> Pune to Nashik Cab</Link>

                  <Link className="mx-md-2" to="/Pune-Airport-Pickup-and-Drop"><i className="fas fa-car darkcolorrr"></i> Pune Airport Pickup and Drop</Link>

                  <Link className="mx-md-2" to="/Pune-To-Mumbai-Airport-Cab"><i className="fas fa-car darkcolorrr"></i> Pune To Mumbai Airport Cab</Link>

                  <Link className="mx-md-2" to="/Mumbai-To-Pune-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai To Pune Cab</Link>

                  <Link className="mx-md-2" to="/Mumbai-To-Mahabaleshwar-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai To Mahabaleshwar Cab</Link>

                  <Link className="mx-md-2" to="/Mumbai-To-Kolhapur-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai To Kolhapur Cab</Link>


                  <Link className="mx-md-2" to="/Mumbai-To-Shirdi-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai To Shirdi Cab</Link>


                </div>
              </div>
            </div>


            {/* Footer Column 2 */}
            <div className="footer-column col-lg-3 col-md-6 col-sm-12">
              <div className="footer-widget links-widget">
                <h4 className="widget-title">Services</h4>
                <div className="widget-content">




                  <Link className="mx-md-2" to="/Mumbai-To-Nashik-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai To Nashik Cab</Link>

                  <Link className="mx-md-2" to="/Mumbai-Airport-To-Pune-Cab"><i className="fas fa-car darkcolorrr"></i> Mumbai Airport To Pune Cab</Link>

                  <Link className="mx-md-2" to="/Kolhapur-To-Pune-Cab"><i className="fas fa-car darkcolorrr"></i> Kolhapur To Pune Cab</Link>

                  <Link className="mx-md-2" to="/Kolhapur-To-Mumbai-Cab"><i className="fas fa-car darkcolorrr"></i> Kolhapur To Mumbai Cab</Link>

                  <Link className="mx-md-2" to="/Sangli-To-Pune-Cab"><i className="fas fa-car darkcolorrr"></i> Sangli To Pune Cab</Link>

                  <Link className="mx-md-2" to="/One-Way-Taxi-in-Pune"><i className="fas fa-car darkcolorrr"></i> One Way Taxi in Pune</Link>

                  <Link className="mx-md-2" to="/Best-Cab-Service-in-Pune"><i className="fas fa-car darkcolorrr"></i> Best Cab Service in Pune</Link>

                  <Link className="mx-md-2" to="/Outstation-Cabs-Pune"><i className="fas fa-car darkcolorrr"></i> Outstation Cabs Pune</Link>


                  <Link className="mx-md-2" to="/Swift-Dzire-Hire-in-Pune"><i className="fas fa-car darkcolorrr"></i> Swift Dzire Hire in Pune</Link>

                  <Link className="mx-md-2" to="/Xcent-Hyundai-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Xcent Hyundai On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Nexa-Ciaz-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Nexa Ciaz On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Honda-City-On-Rent-In-Pune"><i className="fas fa-car darkcolorrr"></i> Honda City On Rent In Pune</Link>

                  <Link className="mx-md-2" to="/Ertiga-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Ertiga On Rent in Pune</Link>

                </div>
              </div>
            </div>

            {/* Footer Column 2 */}
            <div className="footer-column col-lg-3 col-md-6 col-sm-12">
              <div className="footer-widget links-widget">
                <h4 className="widget-title">Services</h4>
                <div className="widget-content">





                  <Link className="mx-md-2" to="/Innova-Cab-for-Outstation-in-Pune"><i className="fas fa-car darkcolorrr"></i> Innova Cab for Outstation in Pune</Link>

                  <Link className="mx-md-2" to="/Innova-Crysta-on-Rent-in-Pimpri-Chinchwad"><i className="fas fa-car darkcolorrr"></i> Innova Crysta on Rent in Pimpri Chinchwad</Link>

                  <Link className="mx-md-2" to="/Fortuner-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Fortuner On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Mercedes-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Mercedes On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Audi-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Audi On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/BMW-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> BMW On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Jaguar-Hire-in-Pune"><i className="fas fa-car darkcolorrr"></i> Jaguar Hire in Pune</Link>

                  <Link className="mx-md-2" to="/Tata-Winger-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Tata Winger On Rent in Pune</Link>

                  <Link className="mx-md-2" to="/Tempo-Traveller-On-Rent-in-Pune-for-Outstation"><i className="fas fa-car darkcolorrr"></i> Tempo Traveller On Rent in Pune for Outstation </Link>

                  <Link className="mx-md-2" to="/Urbania-On-Rent-in-Pune"><i className="fas fa-car darkcolorrr"></i> Urbania On Rent in Pune</Link>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="auto-container">
          <div className="inner-container text-center">
            <p className="copyright-text align-self-center text-center">
              All Rights Reserved &copy;  <span className="darkcolorrr">SHREE Tours & Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
              <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
